import React, { useState } from 'react';
import { ethers } from 'ethers';
import Card from '../Common/Card';
import Button from '../Common/Button';
import Input from '../Common/Input';
import PlanCard from '../Invest/PlanCard';
import { useWeb3 } from '../../context/Web3Context';
import { notify, removeNotify } from '../../utils/notify';
import { parseContractError } from '../../utils/errors';
import { parseUSDT } from '../../utils/format';

const VirtualInvestor = ({ onChange }) => {
  const { contract } = useWeb3();
  const [mode, setMode] = useState('virtual');
  const [addr, setAddr] = useState('');
  const [amount, setAmount] = useState('');
  const [ref, setRef] = useState('');
  const [plan, setPlan] = useState(0);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!contract) return;
    if (!ethers.utils.isAddress(addr)) {
      notify.error('Invalid wallet address');
      return;
    }
    const parsed = parseUSDT(amount);
    if (parsed.lte(0)) {
      notify.error('Enter a valid amount');
      return;
    }
    setBusy(true);
    let lid = null;
    try {
      lid = notify.loading(`Sending ${mode} investment...`);
      const refId = ref ? parseInt(ref, 10) : 0;
      const tx = mode === 'virtual'
        ? await contract.virtualInvestment(addr, parsed, refId, plan)
        : await contract.leaderInvestment(addr, parsed, refId, plan);
      await tx.wait();
      removeNotify(lid); lid = null;
      notify.success(`${mode === 'virtual' ? 'Virtual' : 'Leader'} investment placed`);
      setAddr(''); setAmount(''); setRef('');
      onChange && onChange();
    } catch (err) {
      if (lid) removeNotify(lid);
      notify.error(parseContractError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card title="Virtual / Leader Investment" subtitle="Issue off-chain credit to a user wallet">
      <div className="tab-group" style={{ marginBottom: 16 }}>
        <button
          className={`tab-btn ${mode === 'virtual' ? 'active' : ''}`}
          onClick={() => setMode('virtual')}
        >Virtual (earns ROI)</button>
        <button
          className={`tab-btn ${mode === 'leader' ? 'active' : ''}`}
          onClick={() => setMode('leader')}
        >Leader (no ROI)</button>
      </div>

      <Input
        label="User Wallet"
        value={addr}
        onChange={(e) => setAddr(e.target.value)}
        placeholder="0x..."
      />

      <Input
        label="Referrer ID (optional)"
        value={ref}
        onChange={(e) => setRef(e.target.value.replace(/[^0-9]/g, ''))}
        placeholder="Leave blank for default"
      />

      <div className="form-group">
        <label className="form-label">Plan</label>
        <PlanCard selected={plan} onChange={setPlan} />
      </div>

      <Input
        label="Amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ''))}
        placeholder="0.00"
        suffix="USDT"
      />

      <Button
        variant="primary"
        size="lg"
        block
        loading={busy}
        onClick={submit}
        disabled={!addr || !amount}
      >
        {mode === 'virtual' ? 'Create Virtual Investment' : 'Create Leader Investment'}
      </Button>
    </Card>
  );
};

export default VirtualInvestor;
